import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3216_19549)">
      <path
        d="M7 8.59994L4.06044 5.66037C3.93722 5.53775 3.77043 5.46895 3.5966 5.46903C3.42276 5.46911 3.25604 5.53807 3.13294 5.66081C3.0718 5.72156 3.02326 5.7938 2.99013 5.87337C2.957 5.95294 2.93993 6.03828 2.93989 6.12447C2.93985 6.21066 2.95684 6.29601 2.9899 6.37562C3.02295 6.45522 3.07142 6.5275 3.1325 6.58831L6.53625 9.9925C6.66356 10.1194 6.83156 10.1837 6.99913 10.1837C7.16844 10.185 7.336 10.1202 7.46331 9.9925L10.8675 6.58875C10.9901 6.46553 11.0589 6.29875 11.0588 6.12491C11.0588 5.95107 10.9898 5.78435 10.8671 5.66125C10.8063 5.60008 10.7341 5.55151 10.6546 5.51835C10.575 5.48518 10.4897 5.46806 10.4035 5.46798C10.3173 5.4679 10.2319 5.48485 10.1523 5.51787C10.0727 5.55089 10.0004 5.59932 9.93956 5.66037L7 8.59994ZM7 14C3.13381 14 0 10.8662 0 7C0 3.13381 3.13381 0 7 0C10.8662 0 14 3.13381 14 7C14 10.8662 10.8662 14 7 14Z"
        fill="#5A606B"
      />
    </g>
    <defs>
      <clipPath id="clip0_3216_19549">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
